<template>
  <!-- 查询结果 -->
  <div class="searchResult">
    <TopNavigation class="topNavigation"></TopNavigation>
    <div>
      <div class="typeArea">
        <!-- 面包屑 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item>现舱市场</el-breadcrumb-item>
          <el-breadcrumb-item class="bread">查询结果</el-breadcrumb-item>
        </el-breadcrumb>

        <!-- 查询条件 -->
        <div class="conditiobn">
          <div class="title">
            <span>{{statePortForm }}</span>
            <img v-if="statePortForm || endPortForm"  src="@/assets/images/Group 98@2x(1).png" alt="" />
            <span>{{endPortForm}}</span>
          </div>
          <div class="delivery-main">
            <div class="delivery-main-box youjiantou">
              <img src="@/assets/images/定位.png" alt="" />
              <div class="address">
                <div>起运港</div>
                <el-select
                  v-model="searchQuery1JXYJ"
                  clearable
                  filterable
                  placeholder="请选择"
                  @change="changeQyg"
                >
                  <el-option
                    v-for="item in qiYGTitleList"
                    :key="item.id"
                    :label="item.name_cn + '-' + item.name_en"
                    :value="item.id"
                    v-show="item.display_range==0 || item.display_range==1"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="youbian">
                <img src="../../assets/images/Group 92.png" />
              </div>
            </div>

            <div class="delivery-main-box">
              <img src="@/assets/images/定位.png" alt="" />
              <div class="address">
                <div>目的港</div>
                <el-select
                  v-model="searchQuery2JXYJ"
                  clearable
                  filterable
                  placeholder="请选择"
                  @change="changeMdg"
                  remote
                  reserve-keyword
                  :remote-method="mdgremoteMethod"
                  :loading="mdgloading"
                >
                  <!-- @tab-click="handleClick" -->
                  <el-tabs class="mudig" v-model="activeName">
                    <el-tab-pane
                      :key="index"
                      v-for="(item,index) in muDgList"
                      :label="item.route_name"
                      :name="item.route_name"
                    >
                      <el-option-group
                        v-for="(it,idx) in item.tag_arr"
                        :key="idx"
                        :label="it.tag_name"
                        :value="it.tag_id"
                        class="mdglist"
                      >
                        <el-option
                          v-for="(at,adx) in it.port_arr"
                          :key="adx"
                          :label="at.port_name + '-' + at.name_en"
                          :value="at.port_id"
                        >
                        </el-option>
                      </el-option-group>
                    </el-tab-pane>
                  </el-tabs>
                </el-select>
              </div>
            </div>
            <div class="delivery-main-box">
              <img src="@/assets/images/箱型.png" alt="" />
              <div class="address">
                <div>箱型</div>
                <el-select
                  :multiple-limit="3"
                  multiple
                  collapse-tags
                  class="xiangxing"
                  clearable
                  v-model="searchQuery3JXYJ"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in boxTypeList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.name"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="delivery-main-box">
              <img src="@/assets/images/日期.png" alt="" />
              <div class="address">
                <div>开航起止日期</div>
                <el-date-picker
                  :picker-options="pickerOptions"
                  value-format="yyyy-MM-dd"
                  prefix-icon="null"
                  class="picker"
                  v-model="DateValue1"
                  type="daterange"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                >
                </el-date-picker>
              </div>
            </div>

            <div @click="clickSearch" class="search">
              <i class="el-icon-search"></i>
            </div>
          </div>

          <!-- 线条 -->
          <div class="line"></div>

          <!-- 筛选条件 -->
          <div class="condition">
            <img class="img" src="@/assets/images/shaixuan.png" alt="" />
            <span class="span">筛选</span>
            <!-- 排序方式 -->
            <el-cascader
              :disabled="is_vip==0"
              clearable 
              v-model="order_field_type"
              placeholder="排序方式"
              :options="options"
              @change="handleChange"
            ></el-cascader>

             <!-- 选择船公司 -->
             <el-select 
             :disabled="is_vip==0" 
             @change="handleChange"  
             v-model="shipping_company_code" 
             clearable 
             placeholder="请选择船公司"
              filterable
              :loading="loadingShip">
              <el-option
                v-for="item in shippingList"
                :key="item.value"
                :label="item.name_cn+'-'+item.name_en"
                :value="item.code">
              </el-option>
            </el-select>

            <!-- 选择中转、直达 -->
            <el-select :disabled="is_vip==0" @change="handleChange" v-model="is_transit" clearable placeholder="请选择中转/直达">
              <el-option label="直达" value="0"></el-option>
              <el-option label="中转" value="1"></el-option>
            </el-select>

            <!-- 选择箱源 -->
            <el-select :disabled="is_vip==0" @change="handleChange" v-model="box_source" clearable placeholder="请选择箱源">
                <el-option label="全部" value=""></el-option>
                <el-option
                  v-for="item in boxsourceList"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value">
                </el-option>
            </el-select>
          </div>
        </div>
        <!-- 查询结果 -->
        <div v-if="total==0"  class="result" v-loading="loading" element-loading-text="数据加载中，请稍等">
          <el-empty :image-size="200" description="你查询的价格暂无数据，可以联系在线客服人工报价"></el-empty>
          <div class="empty-btn">
            <el-button class="fymx fr" @click="onlineMessageNAN">在线留言</el-button>
            <el-button class="fymx" @click="showKefunNAN">联系客服</el-button>
          </div>
        </div>

        <div v-if="total>0 && is_vip!=0" class="result" v-loading="loading" element-loading-text="数据加载中，请稍等">
          <!-- 展示 -->
          <!-- 表头 -->
          <div class="table-header">
            <div>船公司</div>
            <div class="qi">起运港</div>
            <div class="mu">目的港</div>
            <div
            v-for="(item,index) in boxTitleList"
            :key="index"
            class="gp"
            :class="{'hq':index==boxTitleList.length-1}"
            >
                {{item}}
            </div>
            <!-- <div >20GP</div>
            <div>40GP</div>
            <div class="hq">40HQ</div> -->
          </div>
          <div class="table-tbody">
            <div 
            class="neirong"
            v-for="(item,index) in resultsList"
            :key="index"
            >
              <div class="shang">
                <div class="shang-le">
                  <div class="logo">
                    <img :src="item.shipping_company.logo" alt="" />
                  </div>
                  <div class="qiyun">
                    <div class="date"><span class="jiacu">ETD:</span>{{item.etd}}</div>
                    <div class="address">{{item.pol_name}}</div>
                  </div>
                  <div class="dao">
                    <div class="tian">{{item.shipping_date}}天</div> 
                    <img src="@/assets/images/Group 113@2x.png" alt="" />
                    <div class="zhida">{{item.is_transit==1?'中转':'直达'}}</div>
                  </div>
                  <div class="qiyun">
                    <div class="date"><span class="jiacu">ETA:</span>{{item.eta}}</div>
                    <div class="address">{{item.pod_name}}</div>
                  </div>
                  <div class="qian">
                      <div>
                        <span class="qian-tit">总计费用：</span>
                        <span
                        v-for="(it,ind) in item.basic_freight"
                        :key="ind"
                        class="sumPrice"
                        >
                             {{ it.price=='--'?'--': '$'+it.price }}
                        </span>
                       
                      </div>
                      <div>
                      <span class="qian-tit qian-tite">数量：</span>
                      <span
                      v-for="(it,ind) in item.basic_freight"
                      :key="ind"
                      class="sumPrice"
                      >
                          x{{it.number}}
                      </span>
                      
                    </div>
                  </div>
                  
                </div>

                <!-- <div class="btn">
                  <el-button  @click="openDrawer(item)">价格明细</el-button>
                  <el-button  class="dc" @click="dingcang(item)">订舱</el-button>
                  <el-button class="dc" @click="faqi(item)">舱位确认</el-button>
                </div> -->
                
              </div>
              <div class="xia xiaxia">
                <div class="youbian">供应商编号：{{item.supplier_info.sn}}</div>
                <div class="youbian">舱位号：{{item.order_sn}} <span class="copy"  @click="getCopy(item.order_sn)">复制</span></div>
                <div class="youbian">航线：{{item.routeCd}}</div>
                <div class="youbian">船名/航次：{{item.vessel}}/{{item.voyage}}</div>
                <div>发布时间：{{item.online_time_desc}}</div>
              </div>
              <div class="zhong">
                
                <div class="kuan">运输条款：{{item.transportation_terms}}</div>
                <div class="kuan">箱源：{{item.box_source}}</div>
                <div>提单类型：{{item.bill_of_lading_type_desc}}</div>
                <div>
                    截单时间：{{item.cutoff_bill_of_lading_time}}
                </div>
                <div>
                    现舱倒计时：{{daojishi(item.online_time)}}
                </div>
                <!-- <div>
                        截单时间：2024-11-12 12:24:00
                    </div>
                    <div>
                        截港时间：2024-11-12 12:24:00
                    </div> -->
              </div>
              <div class="xia">
                <div class="kuan">
                  亏舱费：
                  <el-popover placement="bottom" width="200" trigger="click">
                    <p
                    v-for="(it,ind) in item.basic_freight"
                    :key="ind"
                    >
                        {{it.box_type}}：<span>{{it.dead_freight_name}}</span>
                    </p>
                    <div class="cilick" slot="reference">点击查看</div>
                  </el-popover>
                </div>
                <div class="kuan">
                  超重限制：
                  <el-popover placement="bottom" trigger="click">
                    <el-table :data="item.basic_freight">
                      <el-table-column property="box_type" label="箱型"></el-table-column>
                      <el-table-column property="overweight" label="限重">
                        <template slot-scope="scope">
                            {{scope.row.overweight==0?'不限重':'限重'}}
                        </template>
                      </el-table-column>
                      <el-table-column  width="380" property="weight_limit" label="限重规则">
                          <template slot-scope="scope">
                              <!-- {{scope.row.weight_limit==''?scope.row.weight_limit:'--'}} -->
                              <!-- {{scope.row.weight_limit}} -->
                              <div v-if="scope.row.weight_limit==''">--</div>
                              <div v-else>
                                <el-table
                                border
                                style="width: 500px"
                                  :data="scope.row.weight_limit">
                                  <el-table-column  width="130" property="min_weight" label="最小重量（kgs）">
                                      <template slot-scope="scopeItem">
                                          {{scopeItem.row.min_weight!=''?scopeItem.row.min_weight:'--'}}
                                      </template>
                                  </el-table-column>
                                  <el-table-column  width="130" property="max_weight" label="最大重量（kgs）">
                                      <template slot-scope="scopeItem">
                                          {{scopeItem.row.min_weight!=''?scopeItem.row.max_weight:'--'}}
                                      </template>
                                  </el-table-column>
                                  <el-table-column property="overweight_fees" label="超重费用">
                                      <template slot-scope="scopeItem">
                                        USD {{scopeItem.row.min_weight!=''?scopeItem.row.overweight_fees:'--'}}
                                      </template>
                                  </el-table-column>
                                </el-table>
                              </div>
                          </template>
                      </el-table-column>
                    </el-table>
                    <div class="cilick" slot="reference">点击查看</div>
                  </el-popover>
                </div>
                <div class="kuan">
                  品名要求：
                  <el-popover placement="bottom" width="200" trigger="click">
                    <p
                    v-for="(it,ind) in item.product_name"
                    :key="ind"
                    >
                    {{it}}
                     </p>

                    <div class="cilick" slot="reference">点击查看</div>
                  </el-popover>
                </div>
                <div  class="kuanA">目的港免堆/免用箱：{{item.freetime_desc}}</div>
                <div>运价有效期：{{item.freight_rate_state_time}} - {{item.freight_rate_end_time}}</div>
              </div>
              
              <div class="btn">
                <el-button class="fymx" @click="onlineMessage(item)">在线留言</el-button>
                <el-button class="fymx" @click="showKefu(item)">联系客服</el-button>
                <el-button class="fymx" @click="getPriceCopy(item)">价格复制</el-button>
                <el-button  class="fymx" @click="openDrawer(item)">价格明细</el-button>
                <el-button class="dc" @click="dingcang(item)">订舱</el-button>
              </div>
            </div>
            
          </div>
        </div>

        <div v-if="total>0 && is_vip==0" class="result" v-loading="loading" element-loading-text="数据加载中，请稍等">
          <!-- 展示 -->
          <!-- 表头 -->
          <div class="table-header">
            <div>船公司</div>
            <div class="qi">起运港</div>
            <div class="mu">目的港</div>
            <div
            v-for="(item,index) in boxTitleList"
            :key="index"
            class="gp"
            :class="{'hq':index==boxTitleList.length-1}"
            >
                {{item}}
            </div>
            <!-- <div >20GP</div>
            <div>40GP</div>
            <div class="hq">40HQ</div> -->
          </div>
          <div class="table-tbody noVip">
            <div 
            class="neirong"
            v-for="(item,index) in resultsList.slice(0,2)"
            :key="index"
            >
              <div class="shang">
                <div class="shang-le">
                  <div class="logo">
                    <img :src="item.shipping_company.logo" alt="" />
                  </div>
                  <div class="qiyun">
                    <div class="date"><span class="jiacu">ETD:</span>{{item.etd}}</div>
                    <div class="address">{{item.pol_name}}</div>
                  </div>
                  <div class="dao">
                    <div class="tian">{{item.shipping_date}}天</div> 
                    <img src="@/assets/images/Group 113@2x.png" alt="" />
                    <div class="zhida">{{item.is_transit==1?'中转':'直达'}}</div>
                  </div>
                  <div class="qiyun">
                    <div class="date"><span class="jiacu">ETA:</span>{{item.eta}}</div>
                    <div class="address">{{item.pod_name}}</div>
                  </div>
                  <div class="qian">
                    <div>
                      <span class="qian-tit">总计费用：</span>
                      <span
                      v-for="(it,ind) in item.basic_freight"
                      :key="ind"
                      class="sumPrice"
                      >
                           {{ it.price=='--'?'--': '$'+it.price }}
                      </span>
                      <span
                      v-for="(it,ind) in (boxTitleList.length-item.basic_freight.length)"
                      :key="ind"
                      class="sumPrice">
                      </span>
                    </div>

                    <div>
                      <span class="qian-tit qian-tite">数量：</span>
                      <span
                      v-for="(it,ind) in item.basic_freight"
                      :key="ind"
                      class="sumPrice"
                      >
                        x{{it.number}}
                      </span>
                      <span
                      v-for="(it,ind) in (boxTitleList.length-item.basic_freight.length)"
                      :key="ind"
                      class="sumPrice">
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="xia xiaxia">
                <div class="youbian">供应商编号：{{item.supplier_info.sn}}</div>
                <div class="youbian">舱位号：{{item.order_sn}} <span class="copy"  @click="getCopy(item.order_sn)">复制</span></div>
                <div class="youbian">航线：{{item.routeCd}}</div>
                <div class="youbian">船名/航次：{{item.vessel}}/{{item.voyage}}</div>
                <div>发布时间：{{item.online_time_desc}}</div>
              </div>
              <div class="zhong">
                
                <div class="kuan">运输条款：{{item.transportation_terms}}</div>
                <div class="kuan">箱源：{{item.box_source}}</div>
                <div>提单类型：{{item.bill_of_lading_type_desc}}</div>
                <div>
                    截单时间：{{item.cutoff_bill_of_lading_time}}
                </div>
                <div>
                    <!-- {{item.online_time}} -->
                    现舱倒计时：{{daojishi(item.online_time)}}
                </div>
                <!-- <div>
                        截单时间：2024-11-12 12:24:00
                    </div>
                    <div>
                        截港时间：2024-11-12 12:24:00
                    </div> -->
                    
              </div>
              <div class="xia">
                <div class="kuan">
                  亏舱费：
                  <el-popover placement="bottom" width="200" trigger="click">
                    <p
                    v-for="(it,ind) in item.basic_freight"
                    :key="ind"
                    >
                        {{it.box_type}}：<span>{{it.dead_freight_name}}</span>
                    </p>
                    <div class="cilick" slot="reference">点击查看</div>
                  </el-popover>
                </div>
                <div class="kuan">
                  超重限制：
                  <el-popover placement="bottom" trigger="click">
                    <el-table :data="item.basic_freight">
                      <el-table-column property="box_type" label="箱型"></el-table-column>
                      <el-table-column property="overweight" label="限重">
                        <template slot-scope="scope">
                            {{scope.row.overweight==0?'不限重':'限重'}}
                        </template>
                      </el-table-column>
                      <el-table-column  width="380" property="weight_limit" label="限重规则">
                          <template slot-scope="scope">
                              <!-- {{scope.row.weight_limit==''?scope.row.weight_limit:'--'}} -->
                              <!-- {{scope.row.weight_limit}} -->
                              <div v-if="scope.row.weight_limit==''">--</div>
                              <div v-else>
                                <el-table
                                border
                                style="width: 500px"
                                  :data="scope.row.weight_limit">
                                  <el-table-column  width="130" property="min_weight" label="最小重量（kgs）">
                                      <template slot-scope="scopeItem">
                                          {{scopeItem.row.min_weight!=''?scopeItem.row.min_weight:'--'}}
                                      </template>
                                  </el-table-column>
                                  <el-table-column  width="130" property="max_weight" label="最大重量（kgs）">
                                      <template slot-scope="scopeItem">
                                          {{scopeItem.row.min_weight!=''?scopeItem.row.max_weight:'--'}}
                                      </template>
                                  </el-table-column>
                                  <el-table-column property="overweight_fees" label="超重费用">
                                      <template slot-scope="scopeItem">
                                        USD {{scopeItem.row.min_weight!=''?scopeItem.row.overweight_fees:'--'}}
                                      </template>
                                  </el-table-column>
                                </el-table>
                              </div>
                          </template>
                      </el-table-column>
                    </el-table>
                    <div class="cilick" slot="reference">点击查看</div>
                  </el-popover>
                </div>
                <div class="kuan">
                  品名要求：
                  <el-popover placement="bottom" width="200" trigger="click">
                    <p
                    v-for="(it,ind) in item.product_name"
                    :key="ind"
                    >
                    {{it}}
                     </p>

                    <div class="cilick" slot="reference">点击查看</div>
                  </el-popover>
                </div>
                <div class="kuanA">目的港免堆/免用箱：{{item.freetime_desc}}</div>
                <div>运价有效期：{{item.freight_rate_state_time}} - {{item.freight_rate_end_time}}</div>
              </div>
              <div class="btn">
                <el-button class="fymx" @click="onlineMessage(item)">在线留言</el-button>
                <el-button class="fymx" @click="showKefu(item)">联系客服</el-button>
                <el-button class="fymx" @click="getPriceCopy(item)">价格复制</el-button>
                <el-button  class="fymx" @click="openDrawer(item)">价格明细</el-button>
                <el-button class="dc" @click="dingcang(item)">订舱</el-button>
              </div>
            </div>
            <div 
            class="neirong neirongzhezhao"
            v-for="(item,index) in resultsList.slice(2)"
            :key="index"
            >
              <div class="shang">
                <div class="shang-le">
                  <div class="logo">
                    <img :src="item.shipping_company.logo" alt="" />
                  </div>
                  <div class="qiyun">
                    <div class="date"><span class="jiacu">ETD:</span>{{item.etd}}</div>
                    <div class="address">{{item.pol_name}}</div>
                  </div>
                  <div class="dao">
                    <div class="tian">{{item.shipping_date}}天</div> 
                    <img src="@/assets/images/Group 113@2x.png" alt="" />
                    <div class="zhida">{{item.is_transit==1?'中转':'直达'}}</div>
                  </div>
                  <div class="qiyun">
                    <div class="date"><span class="jiacu">ETA:</span>{{item.eta}}</div>
                    <div class="address">{{item.pod_name}}</div>
                  </div>
                  <div class="qian">
                    <div>
                      <span class="qian-tit">总计费用：</span>
                      <span
                      v-for="(it,ind) in item.basic_freight"
                      :key="ind"
                      class="sumPrice"
                      >
                           {{ it.price=='--'?'--': '$'+it.price }}
                      </span>
                      <span
                      v-for="(it,ind) in (boxTitleList.length-item.basic_freight.length)"
                      :key="ind"
                      class="sumPrice">
                      </span>
                    </div>

                    <div>
                      <span class="qian-tit qian-tite">数量：</span>
                      <span
                      v-for="(it,ind) in item.basic_freight"
                      :key="ind"
                      class="sumPrice"
                      >
                        {{it.number}}
                      </span>
                      <span
                      v-for="(it,ind) in (boxTitleList.length-item.basic_freight.length)"
                      :key="ind"
                      class="sumPrice">
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="xia xiaxia">
                <div class="youbian">供应商编号：{{item.supplier_info.sn}}</div>
                <div class="youbian">舱位号：{{item.order_sn}} <span class="copy">复制</span></div>
                <div class="youbian">航线：{{item.routeCd}}</div>
                <div class="youbian">船名/航次：{{item.vessel}}/{{item.voyage}}</div>
                <div>发布时间：{{item.online_time_desc}}</div>
              </div>
              <div class="zhong">
                
                <div class="kuan">运输条款：{{item.transportation_terms}}</div>
                <div class="kuan">箱源：{{item.box_source}}</div>
                <div>提单类型：{{item.bill_of_lading_type_desc}}</div>
                <div>
                    截单时间：{{item.cutoff_bill_of_lading_time}}
                </div>
                <div>
                    现舱倒计时：
                    {{item.online_time}}
                    <!-- 现舱倒计时：{{daojishi(item.online_time)}} -->
                </div>
                <!-- <div>
                        截单时间：2024-11-12 12:24:00
                    </div>
                    <div>
                        截港时间：2024-11-12 12:24:00
                    </div> -->
                    
              </div>
              <div class="xia">
                <div class="kuan">
                  亏舱费：
                  <el-popover placement="bottom" width="200" trigger="click">
                    <p
                    v-for="(it,ind) in item.basic_freight"
                    :key="ind"
                    >
                        {{it.box_type}}：<span>{{it.dead_freight_name}}</span>
                    </p>
                    <div class="cilick" slot="reference">点击查看</div>
                  </el-popover>
                </div>
                <div class="kuan">
                  超重限制：
                  <el-popover placement="bottom" trigger="click">
                    <el-table :data="item.basic_freight">
                      <el-table-column property="box_type" label="箱型"></el-table-column>
                      <el-table-column property="overweight" label="限重">
                        <template slot-scope="scope">
                            {{scope.row.overweight==0?'不限重':'限重'}}
                        </template>
                      </el-table-column>
                      <el-table-column  width="380" property="weight_limit" label="限重规则">
                          <template slot-scope="scope">
                              <!-- {{scope.row.weight_limit==''?scope.row.weight_limit:'--'}} -->
                              <!-- {{scope.row.weight_limit}} -->
                              <div v-if="scope.row.weight_limit==''">--</div>
                              <div v-else>
                                <el-table
                                border
                                style="width: 500px"
                                  :data="scope.row.weight_limit">
                                  <el-table-column  width="130" property="min_weight" label="最小重量（kgs）">
                                      <template slot-scope="scopeItem">
                                          {{scopeItem.row.min_weight!=''?scopeItem.row.min_weight:'--'}}
                                      </template>
                                  </el-table-column>
                                  <el-table-column  width="130" property="max_weight" label="最大重量（kgs）">
                                      <template slot-scope="scopeItem">
                                          {{scopeItem.row.min_weight!=''?scopeItem.row.max_weight:'--'}}
                                      </template>
                                  </el-table-column>
                                  <el-table-column property="overweight_fees" label="超重费用">
                                      <template slot-scope="scopeItem">
                                        USD {{scopeItem.row.min_weight!=''?scopeItem.row.overweight_fees:'--'}}
                                      </template>
                                  </el-table-column>
                                </el-table>
                              </div>
                          </template>
                      </el-table-column>
                    </el-table>
                    <div class="cilick" slot="reference">点击查看</div>
                  </el-popover>
                </div>
                <div class="kuan">
                  品名要求：
                  <el-popover placement="bottom" width="200" trigger="click">
                    <p
                    v-for="(it,ind) in item.product_name"
                    :key="ind"
                    >
                    {{it}}
                     </p>

                    <div class="cilick" slot="reference">点击查看</div>
                  </el-popover>
                </div>
                <div  class="kuanA">目的港免堆/免用箱：{{item.freetime_desc}}</div>
                <div>运价有效期：{{item.freight_rate_state_time}} - {{item.freight_rate_end_time}}</div>
              </div>
              <div class="btn">
                <el-button class="fymx">在线留言</el-button>
                <el-button class="fymx">联系客服</el-button>
                <el-button class="fymx">价格复制</el-button>
                <el-button  class="fymx">价格明细</el-button>
                <el-button class="dc">订舱</el-button>
              </div>
            </div>
            <div class="noVip-dialog">
              <div class="novip-tit">
                非会员用户无法查看更多数据
              </div>
              <div class="noVip-line">
                <div class="left-line"></div>
                <div class="word">
                  开通解锁更多特权
                </div>
                <div class="left-line"></div>
              </div>
              <div class="noVip-gongneng">
                <div class="gongnengYi">
                  <div>
                    <img src="@/assets/images/fhy1.png" alt="">
                  </div>
                  <div>
                    查看更多数据
                  </div>
                </div>
                <div class="gongnengYi">
                  <div>
                    <img src="@/assets/images/fhy2.png" alt="">
                  </div>
                  <div>
                    使用筛选功能
                  </div>
                </div>
                <div class="gongnengYi">
                  <div>
                    <img src="@/assets/images/fhy3.png" alt="">
                  </div>
                  <div>
                    可使用盯舱宝
                  </div>
                </div>
              </div>
              <div class="noVip-btn">
                <el-button class="noVip-qy" @click="$router.push('/OpenMembership')">查看会员权益</el-button>
                <el-button class="noVip-hy" @click="$router.push('/OpenMembership')">开通会员</el-button>
              </div>
            </div>
          </div>
        </div>

        <!-- 分页 -->
        <el-pagination
            v-if="total>0 && is_vip==0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page_no"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>

    <Bottom />

     <!-- 价格明细抽屉 -->
      <el-drawer
        title="价格明细"
        :visible.sync="table"
        direction="rtl"
        :with-header="false"
        size="50%">
        <div class="drawer-title">
          <div class="word">
            价格明细<span>实际费用以账单为准</span>
          </div>
          <div>
            <i @click="table = false" class="el-icon-close"></i>
          </div>
        </div>
        <div class="tab-det">
          <div class="tab-tit">基本海运费</div>
          <table class="table datab" border>
            <tr class="theader">
              <td class="first">费用名称</td>
              <td v-for="(item,ind) in drawerbasic_freight" :key="ind">
                  {{item.box_type}}
              </td>
              <td>单位</td>
            </tr>
            <tr class="tbody">
              <td  class="first">基本海运费</td>
              <td v-for="(item,ind) in drawerbasic_freight" :key="ind">
                价格：USD {{item.price}}<br>
              </td>
              <td>箱</td>
            </tr>
          </table>

          <div class="tab-tit renminbi">海运附加费</div>
          <table class="table datab" border>
            <tr class="theader">
              <td class="first">费用名称</td>
              <td>费用类型</td>
              <td colspan="2">费用内容</td>
            </tr>
            <tr class="tbody" v-for="(item,index) in priceList" :key="index">
              <td  class="first">{{item.surcharge_title}}</td>
              <td>{{item.cost_unit == 1 ? '箱' : '票' }}</td>
              <!-- <td>{{item.fee}}</td> -->
              <td  colspan="2" v-if="item.cost_unit == 2">USD {{item.vote_cost}}</td>
              <td class="xiaotab" v-if="item.cost_unit == 1">

                <table  class="table">
                  <tr  class="theader">
                    <td v-for="(obj,ind) in item.box_cost" :key="ind">
                      <div v-for="(value, key, idx) in obj" :key="idx">
                        {{ key }}
                      </div>
                    </td>
                  </tr>
                  <tr  class="tbody" >
                    <td v-for="(obj,ind) in item.box_cost" :key="ind">
                      <div v-for="(value, key, idx) in obj" :key="idx">
                        USD {{value}}
                      </div>
                    </td>
                  </tr>
                </table>
              </td>
            </tr>
          </table>
          <!-- <div class="tab-tit renminbi">人民币港杂费</div>
            <table v-if="other_cost.length>0"  class="table datab" border>
                <tr class="theader">
                <td class="first">费用名称</td>
                <td>费用类型</td>
                <td colspan="2">收费单位</td>
                </tr>
                <tr class="tbody" v-for="(item,index) in other_cost" :key="index">
                    <td  class="first">{{item.surcharge_title}}</td>
                    <td>{{item.cost_unit == 1 ? '箱' : '票' }}</td>
                    <td  colspan="2" v-if="item.cost_unit == 2">CNY {{item.vote_cost}}</td>
                    <td class="xiaotab" v-if="item.cost_unit == 1">

                        <table  class="table">
                        <tr  class="theader">
                            <td v-for="(obj,ind) in item.box_cost" :key="ind">
                            <div v-for="(value, key, idx) in obj" :key="idx">
                                {{ key }}
                            </div>
                            </td>
                        </tr>
                        <tr  class="tbody" >
                            <td v-for="(obj,ind) in item.box_cost" :key="ind">
                            <div v-for="(value, key, idx) in obj" :key="idx">
                              CNY {{value}}
                            </div>
                            </td>
                        </tr>
                        </table>
                    </td>
                </tr>
            </table>
            <table v-if="other_cost.length==0" class="table datab" border>
                <tr class="theader">
                <td class="first">费用名称</td>
                <td>费用类型</td>
                <td colspan="2">收费单位</td>
                </tr>
                <tr class="tbody zanweu">
                    <td class="zanwu" colspan="3">暂无数据</td>
                </tr>
            </table> -->
        </div>
        <div class="drawer__footer">
          <el-button class="quxiao" @click="table = false">取 消</el-button>
          <el-button class="dingcanggg" @click="table = false">去订舱</el-button>
        </div>
      </el-drawer>

      <!-- 选择想要确定的舱位数量 -->
      <el-dialog width="35%" title="舱位确认" :visible.sync="dialogFormVisible">
        <!-- {{dialogBox}} -->
        <div class="dialogBox">
          <div v-for="(item,index) in dialogBox.boxtype" :key="index">
            <div>{{item.box_type}}</div>
            <el-input-number v-model="item.number" :min="0" :max="100" label="描述文字"></el-input-number>
          </div>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="tijiaoFaqi">发 起</el-button>
          <!-- <el-button type="primary" @click="tijiaoFaqi">确 定</el-button> -->
        </div>
      </el-dialog>
      

      <el-dialog title="在线留言" :visible.sync="dialogLiuyan" class="ddDialog" top="6vh">
            <span slot="title" class="dialog-title">在线留言</span>
            <div class="dd-con">
                <div class="dd-con-yi txhz">
                    <div class="dd-con-yi-width">
                        <div class="dd-con-tit"><span>*</span>起运港</div>
                        <el-input readonly v-model="onlineForm.pol_name" placeholder=""></el-input>
                    </div>
                    <div class="dd-con-yi-width">
                        <div class="dd-con-tit"><span>*</span>目的港</div>
                        <el-input readonly v-model="onlineForm.pod_name" placeholder=""></el-input>
                    </div>
                </div>
                <div class="dd-con-yi txhz">
                    <div class="dd-con-yi-width">
                        <div class="dd-con-tit"><span>*</span>箱型</div>
                        <el-popover
                            placement="bottom"
                            trigger="click">
                            <div class="dd-con-yi-boxtype">
                                <div 
                                class="boxtype txhz"
                                :class="{'boxtypeLine' : index != onlineForm.box_quantity.length-1}"
                                v-for="(item,index) in onlineForm.box_quantity"
                                :key="index"
                                >
                                    <div class="boxtype-left">{{item.box}}</div>
                                    <div class="boxtype-right">
                                        <el-input-number size="mini" v-model="item.quantity"></el-input-number>
                                    </div>
                                </div>
                            </div>
                            <div class="dd-con-yi-box txhz" slot="reference">
                              <div class="txhz">
                                  <div   
                                      class="boxSty txhz"
                                      v-for="(item,index) in onlineForm.box_quantity"
                                      :key="index"
                                      >
                                      <div>{{item.box}}*{{item.quantity}}</div>
                                      <!-- <div class="el-error">
                                          <i class="el-icon-close"></i>
                                      </div> -->
                                  </div>
                              </div>
                              <el-button class="icondown"  type="text" icon="el-icon-arrow-down"></el-button>
                          </div>
                        </el-popover>
                    </div>
                    <div class="dd-con-yi-width">
                        <div class="dd-con-tit"><span>*</span>预计发货日期</div>
                        <el-date-picker
                        value-format="yyyy-MM-dd"
                        prefix-icon="null"
                        v-model="onlineForm.shipment_date"
                        type="date"
                        placeholder="">
                        </el-date-picker>
                    </div>
                </div>
                <div class="dd-con-yi txhz">
                    <div class="dd-con-yi-width">
                        <div class="dd-con-tit"><span>*</span>姓名</div>
                        <el-input v-model="onlineForm.nickname" placeholder=""></el-input>
                    </div>
                    <div class="dd-con-yi-width">
                        <div class="dd-con-tit"><span>*</span>电子邮箱</div>
                        <el-input v-model="onlineForm.email" placeholder=""></el-input>
                    </div>
                </div>
                <div class="dd-con-er">
                    <div class="dd-con-tit"><span>*</span>留言内容</div>
                    <el-input
                        type="textarea"
                        :rows="2"
                        placeholder=""
                        v-model="onlineForm.content">
                    </el-input>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogLiuyan = false" class="quxiao">取消</el-button>
                <el-button type="primary" @click="submitMessage" class="queding">发送</el-button>
            </div>
        </el-dialog>

        <!-- 客服信息弹窗 -->
        <el-dialog class="appdialog" :visible.sync="dialogVisible" :show-close="false" v-draggable>
            <span slot="title" class="dialog-title">
              <div class="applan"><div class="appfen"></div></div>
            </span>

            <div class="dingwei">
                <i class="el-icon-close" @click="dialogVisible=false"></i>
                <div class="dizhi">
                    <img class="kflogoIng" src="@/assets/images/hpcopy/logo.png" alt="">
                    <div>
                        <!-- <div class="dx-tit">订好舱</div>
                        <div class="dz-wprd">
                            (<span>WCA ID</span>: 135278; <span>WIFFA ID</span>: W0010169)
                        </div> -->
                    </div>
                </div>
                <div class="dhk-xia">
                    <div class="xia-left">
                        <div class="txDingwei">
                            <img v-if="kefuForm.avatar!=''" class="touxImg" :src="kefuForm.avatar" alt="">
                            <div class="zanwu" v-else>暂无图片</div>
                            <img v-if="kefuForm.avatar!=''" @click="dialogVisibleImg = true" class="delImg" src="@/assets/home/da.png" alt="">
                        </div>
                        <div>
                            <div class="txname">{{kefuForm.nickname}}</div>
                            <div>{{kefuForm.jobs_name}}</div>
                            <div class="neior">青岛市市北区徐州路160号宇恒大厦702室</div>
                            <div class="wangzhi">
                                <img class="img" src="@/assets/home/diqiu.png" alt="">
                                <!-- <a href="https://serve.fulltranslgst.com/" target="_blank">www.fulltranslgst.com</a> -->
                                <a href="https://www.dhcang.com" target="_blank">https://www.dhcang.com</a>
                            </div>
                        </div>
                    </div>
                    <div class="xia-line"></div>
                    <div class="xia-right">
                        <div class="tx-xx">
                            <img class="tx-img" src="@/assets/home/email.png" alt="">
                            <div v-if="total>0" class="youxiang txhz">
                                <span class="span">邮箱：</span>
                                <span  @click="openEmail">{{kefuForm.address}}</span>
                                <img  @click="openEmail" class="clickImg" src="@/assets/home/click.png" alt="">
                                <img  v-if="kefuForm.address" @click="getCopy(kefuForm.address)" class="copyimg" src="@/assets/home/copy.png" alt="">
                            </div>
                            <div v-else class="txhz">
                                <span class="span">邮箱：</span>
                                <span>{{kefuForm.address}}</span>
                                <img  v-if="kefuForm.address" @click="getCopy(kefuForm.address)" class="copyimg" src="@/assets/home/copy.png" alt="">
                            </div>
                        </div>
                        <div class="tx-xx">
                            <img class="tx-img" src="@/assets/home/shouji.png" alt="">
                            <div class="txhz">
                                <span class="span">电话：</span>
                                <span>{{kefuForm.phone}}</span>
                                <img  v-if="kefuForm.phone" @click="getCopy(kefuForm.phone)" class="copyimg" src="@/assets/home/copy.png" alt="">
                            </div>
                        </div>
                        <div class="tx-xx">
                            <img class="tx-img" src="@/assets/home/wx.png" alt="">
                            <div class="txhz">
                                <span class="span">微信：</span>
                                <span>{{kefuForm.wechat}}</span>
                                <img  v-if="kefuForm.wechat" @click="getCopy(kefuForm.wechat)" class="copyimg" src="@/assets/home/copy.png" alt="">
                            </div>
                        </div>
                        <div class="tx-xx">
                            <img class="tx-img" src="@/assets/home/dianhua.png" alt="">
                            <div class="txhz">
                                <span class="span">QQ：</span>
                                <span>{{kefuForm.qq}}</span>
                                <img  v-if="kefuForm.qq" @click="getCopy(kefuForm.qq)" class="copyimg" src="@/assets/home/copy.png" alt="">
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>

        <!-- 预览图片 -->
        <el-dialog :visible.sync="dialogVisibleImg"  width="30%">
            <img width="100%" :src="kefuForm.avatar" alt="">
        </el-dialog>

        <!-- 邮箱弹窗 -->
        <el-dialog title="发送邮件" :visible.sync="dialogEmail" class="emailDialog">
            <span slot="title" class="dialog-title">发送邮件</span>
            <div class="dd-con">
                <div class="dd-con-yi">
                    <div class="dd-con-tit"><span>*</span>收件人</div>
                    <el-input readonly v-model="emailForm.email" placeholder=""></el-input>
                </div>
                <div class="dd-con-yi">
                    <div class="dd-con-tit">抄送人</div>
                    <el-tag
                    :key="tag"
                    v-for="tag in emailForm.cc_to"
                    closable
                    :disable-transitions="false"
                    @close="handleClose(tag)">
                    {{tag}}
                    </el-tag>

                    <el-input
                    class="input-new-tag"
                    v-if="inputVisible"
                    v-model="inputValue"
                    ref="saveTagInput"
                    size="small"
                    @keyup.enter.native="handleInputConfirm"
                    @blur="handleInputConfirm"
                    >
                    </el-input>

                    <el-button v-if="!inputVisible && emailForm.cc_to.length<10" class="button-new-tag" size="small" @click="showInput">+ 新增抄送人</el-button>
                </div>
                <div class="dd-con-er">
                    <div class="dd-con-tit"><span>*</span>内容</div>
                    <el-input
                        type="textarea"
                        :rows="2"
                        placeholder=""
                        v-model="emailForm.content">
                    </el-input>
                </div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogEmail = false" class="quxiao">取消</el-button>
                <el-button type="primary" @click="submitEmail" class="queding">发送</el-button>
            </div>
        </el-dialog>
  </div>
</template>

<script>
import Bottom from "../HP/BottomPage.vue";
import TopNavigation from "../HP/TopNavigationB.vue";
import {
  basePortValidList,
  destinationPortRouteTypeValidList,
  baseCasesGaugeTypeValidList,
  currentCabinSelect,
  askAboutShippingSpace,
  baseShippingCompanyValidList,dict,
  shipReplyAdd,
  sendEmail,
} from "@/api/api";
export default {
  components: {
    Bottom,
    TopNavigation,
  },
  data() {
    return {
      searchQuery1JXYJ: "",
      searchQuery2JXYJ: "",
      searchQuery3JXYJ: [],
      boxTitleList:[],
      DateValue1: "",
      is_transit:'',
      shipping_company_code:'',
      box_source:'',
      order_field_type:'',
      qiYGTitleList: [],
      muDgList: [],
      mdgloading:false,
      boxTypeList: [],
      // 筛选
      options: [
        {
          value: "etd",
          label: "开航时间最近",
        },
        {
          value: "tt",
          label: "航程最短",
        },
      ],
      value: "",
      currentPage: 5,
      // 页面跳转带来的参数
      canshu: {},
      //加载
      loading: false,
      headers:{
            token: localStorage.getItem('token')
        },
        // 查询结果：
        resultsList:[],
        // 总条数
        total:0,
        // 价格明细抽屉是否打开
        table: false,
        drawerbasic_freight:[],
        priceList:[],
        other_cost:[],
        statePortForm:'',
        endPortForm:'',
        activeName:'',
        page_no:1,
        page_size:10,
        is_vip:JSON.parse(localStorage.getItem('userInfo')).is_vip,
        pickerMinDate: null,
        pickerMaxDate: null,
        daySanshi: 30 * 24 * 3600 * 1000,
        pickerOptions: {
            onPick: ({  minDate }) => {
            if (minDate && this.pickerMinDate) {
              this.pickerMinDate = null;
            } else if (minDate) {
              this.pickerMinDate = minDate.getTime();
            }
          },
          disabledDate: (time) => {
            if (this.pickerMinDate) {
              return (time.getTime() - 2 * 3600 * 1000 * 24) < Date.now() - 8.64e7 || (time.getTime() > (this.pickerMinDate + this.daySanshi)) || (time.getTime() < (this.pickerMinDate - this.daySanshi));
            }
            //  return false;
            return (time.getTime() - 2 * 3600 * 1000 * 24) < Date.now() - 8.64e7
          }
        },
        intervalId: null,
        // 当前时间
        timeA:'',
        shippingList:[],
        boxsourceList:[],
        // 要确定的舱位箱型数量
        dialogFormVisible:false,
        dialogBox:{
          shipping_space_id:'',
          boxtype:[]
        },
        loadingShip:false,

        isSubmitting:false,
        // 在线留言
        dialogLiuyan:false,
        onlineForm:{
          kefu_id:'',
          pol_id:'',
          pol_name:'',
          pod_id:'',
          pod_name:'',
          nickname:'',
          email:'',
          box_quantity:[],
          content:'',
          shipment_date:'',
          shipping_space_info:{},
        },

        dialogVisible:false,
        dialogVisibleImg:false,
        kefuForm:{},

        emailForm:{
          type:1,
          email:'',
          kefu_id:'',
          cc_to:[],
          content:'',
          shippingSpace:{
            supplier_info:'',
            order_sn:'',
            pol_name: "--", // 起运港名称
            pod_name: "--", // 目的港名称
            container_type:'', // 搜索的箱型
            date_start:'',
            date_end:'',
            shipping_company: "--",  // 船运公司
            routeCd: "--",  // 航线
            vessel: "--", // 船名
            voyage: "--",  //船次
            basic_freight: [],
            transportation_terms: "--", // 运输条款,
            box_source: "--", // 箱源
            bill_of_lading_type: "--", // 提单类型，主单分单
            is_transit: "--",  // 中转直达
            etd: "--",  // ETD
            freetime_desc: "--",  // freetime
            freight_rate_state_time: "--",  // 运价有效期开始日期
            freight_rate_end_time: "--",  // 运价有效期结束日期
          },
          mjdmInfo:{},
      },
      inputVisible: false,
      inputValue: '',

      cunForm:{},
      dialogEmail:false,
    };
  },
  setup() {},
  methods: {
    handleClose(tag) {
        this.emailForm.cc_to.splice(this.emailForm.cc_to.indexOf(tag), 1);
    },
    showInput() {
        this.inputVisible = true;
        this.$nextTick(() => {
            this.$refs.saveTagInput.$refs.input.focus();
        });
    },
    handleInputConfirm() {
        let inputValue = this.inputValue;
        if (inputValue) {
            // 判断验证是否通过
            if (!this.validFn(inputValue)) {
                return;
            }

            if(this.emailForm.cc_to.length<=9){
                this.emailForm.cc_to.push(inputValue);
            }else{
                this.$message({
                    type:'error',
                    message:'最多添加十个抄送人'
                })
            }
        }
        this.inputVisible = false;
        this.inputValue = '';
    },
    openEmail(){
      let e = this.cunForm
      this.dialogEmail = true
      
      this.emailForm.email = e.kefu_info.address
      this.emailForm.kefu_id = e.kefu_info.id

      let yunjia = []
      for (let i = 0; i < e.basic_freight.length; i++) {
          if(e.basic_freight[i].box_type!='' && e.basic_freight[i].price!='--'){
              yunjia.push({
                  price:e.basic_freight[i].price ,
                  box_type:e.basic_freight[i].box_type
              })
          }
      }
      let zz = e.is_transit == 1 ? '中转' : '直达'
      let ggsSn =  e.supplier_info.sn
      if(e.type==3){
        ggsSn = '上海泛远国际货运代理有限公司'
      }

      this.emailForm.shippingSpace = {
          supplier_info:ggsSn,
          order_sn:e.order_sn,
          pol_name: e.pol_name, // 起运港名称
          pod_name: e.pod_name, // 目的港名称
          container_type: this.searchQuery3JXYJ,
          date_start: this.DateValue1[0],
          date_end: this.DateValue1[1],
          shipping_company: e.shipping_company,  // 船运公司
          routeCd: e.routeCd ,  // 航线
          vessel: e.vessel, // 船名
          voyage: e.voyage,  //船次
          basic_freight: yunjia,
          transportation_terms: e.transportation_terms, // 运输条款,
          box_source: e.box_source, // 箱源
          bill_of_lading_type: e.bill_of_lading_type_desc_en, // 提单类型，主单分单
          is_transit: zz,  // 中转直达
          etd: e.etd,  // ETD
          freetime_desc: e.freetime_desc,  // freetime
          freight_rate_state_time: e.freight_rate_state_time,  // 运价有效期开始日期
          freight_rate_end_time: e.freight_rate_end_time,  // 运价有效期结束日期
      }
    },
    async submitEmail(){
        try {
            // 判断验证是否通过
            if (this.isSubmitting) return;  // 防止连点操作  

            this.isSubmitting = true;
            const res = await sendEmail(this.emailForm,this.headers)
            if(res.code==1){
                this.isSubmitting = false;

                this.$message({
                    type:"success",
                    message:'发送成功'
                })
                this.dialogEmail = false
                this.emailForm = {
                    type:1,
                    email:'',
                    kefu_id:'',
                    cc_to:[],
                    content:'',
                    shippingSpace:{
                        supplier_info:'',
                        order_sn:'',
                        pol_name: "--", // 起运港名称
                        pod_name: "--", // 目的港名称
                        container_type:'', // 搜索的箱型
                        date_start:'',
                        date_end:'',
                        shipping_company: "--",  // 船运公司
                        routeCd: "--",  // 航线
                        vessel: "--", // 船名
                        voyage: "--",  //船次
                        basic_freight: [],
                        transportation_terms: "--", // 运输条款,
                        box_source: "--", // 箱源
                        bill_of_lading_type: "--", // 提单类型，主单分单
                        is_transit: "--",  // 中转直达
                        etd: "--",  // ETD
                        freetime_desc: "--",  // freetime
                        freight_rate_state_time: "--",  // 运价有效期开始日期
                        freight_rate_end_time: "--",  // 运价有效期结束日期
                    },
                    mjdmInfo:{},
                }
            }else{
                this.isSubmitting = false;

                this.$message({
                    type:"error",
                    message:res.msg
                })
            }
        } catch (error) {
            console.log(error,'error');
        }
    },
    changeQyg(){
        for (let i = 0; i < this.qiYGTitleList.length; i++) {
            if(this.qiYGTitleList[i].id ==this.searchQuery1JXYJ){
              this.statePortForm = this.qiYGTitleList[i].name_cn+'-'+this.qiYGTitleList[i].name_en
            }
        }
    },
    changeMdg(){
        for (let i = 0; i < this.muDgList.length; i++) {
          for (let j = 0; j < this.muDgList[i].tag_arr.length; j++) {
            for (let k = 0; k < this.muDgList[i].tag_arr[j].port_arr.length; k++) {
              if(this.muDgList[i].tag_arr[j].port_arr[k].port_id==this.searchQuery2JXYJ){
                this.endPortForm = this.muDgList[i].tag_arr[j].port_arr[k].port_name+'-'+this.muDgList[i].tag_arr[j].port_arr[k].name_en
              }
            }
          }
        }
    },
    openDrawer(e){
      this.table = true
      this.drawerbasic_freight = e.basic_freight
      this.priceList = e.surcharge
      this.other_cost = e.other_cost
    },
    handleSizeChange(val) {
      this.page_size = val
      this.searchList()
    },
    handleCurrentChange(val) {
      this.page_no = val
      this.searchList()
    },
    faqi(e){
      let is_authentication= JSON.parse(localStorage.getItem('userInfo')).is_authentication
      if(is_authentication!=2){
          if(is_authentication==0){
            this.$confirm('您还未进行身份认证，请先进行认证', '提示', {confirmButtonText: '去认证',cancelButtonText: '取消',type: 'warning'}).then(async() => {
              this.$router.push({
                name:'UserInfo',
                params:{
                  menuInx: '2'
                }
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              });          
            });
          }else{
            this.$confirm('您的认证还未通过，请等待审核', '提示', {confirmButtonText: '去查看',cancelButtonText: '取消',type: 'warning'}).then(async() => {
              this.$router.push({
                name:'UserInfo',
                params:{
                  menuInx: '2'
                }
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              });          
            });
          }
          
          return
      }

      if(this.is_vip==0){
        this.$message({
          type:'error',
          message:'您还不是会员，请先购买会员'
        })
        return
      }
      
      this.dialogFormVisible = true
      this.dialogBox.shipping_space_id = e.shipping_space_id
      this.dialogBox.boxtype = e.basic_freight

      for (let i = 0; i < this.dialogBox.boxtype.length; i++) {
        this.dialogBox.boxtype[i].number=0
      }
    },
    async tijiaoFaqi(){
      try {
        const res = await askAboutShippingSpace(this.dialogBox,this.headers)
        
        if( res.code == 1 ) {
          this.dialogFormVisible = false
          this.$message({
            type:'success',
            message:'发起成功'
          })
        }else{
          this.$message({
            type:'error',
            message:res.msg
          })
        }
      } catch (error) {
        console.log(error,'失败');
      }
    },
    dingcang(e) {
      let is_authentication= JSON.parse(localStorage.getItem('userInfo')).is_authentication
      if(is_authentication!=2){
        if(is_authentication==0){
            this.$confirm('您还未进行身份认证，请先进行认证', '提示', {confirmButtonText: '去认证',cancelButtonText: '取消',type: 'warning'}).then(async() => {
              this.$router.push({
                name:'UserInfo',
                params:{
                  menuInx: '2'
                }
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              });          
            });
          }else{
            this.$confirm('您的认证还未通过，请等待审核', '提示', {confirmButtonText: '去查看',cancelButtonText: '取消',type: 'warning'}).then(async() => {
              this.$router.push({
                name:'UserInfo',
                params:{
                  menuInx: '2'
                }
              })
            }).catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              });          
            });
          }
        
        return
      }
        if(this.is_vip==0){
          this.$message({
            type:'error',
          message:'您还不是会员，请先购买会员'
          })
          return
        }
        sessionStorage.setItem('parameter',JSON.stringify(e))
      this.$router.push({
        name:"MarketBookingSpace",
        params:e
      });
    },
    handleChange() {
      this.page_no = 1
      this.page_size = 10
      this.searchList()
    },
    // 起运港
    async getQygList() {
      // 起运港列表
      let basePortParams = {
        page_no: 1,
        page_size: 50,
        keyword: "",
      };
      const basePortRes = await basePortValidList(basePortParams);
      if (basePortRes.code == 1) {
        this.qiYGTitleList = basePortRes.data.lists;
      }
    },
    // 目的港
    async getMdgList(e) {
        this.mdgloading = true;
        if(e==undefined){
          e=''
        }
        // 目的港列表
        const res = await destinationPortRouteTypeValidList({
            keyword:e
          });
        if (res.code==1) {
          this.muDgList=res.data
          if(res.data.length>0){
            this.activeName=res.data[0].route_name
          }
          this.mdgloading = false
          // mdgloading:false,
        }
      },
      mdgremoteMethod(query){
        if (query !== '') {
          setTimeout(async () => {
            this.getMdgList(query)
          }, 200);
        } else {
          this.getMdgList();
        }
      },
    // 箱型
    async getBoxTypeList() {
      // 目的港列表
      const res = await baseCasesGaugeTypeValidList();
      if (res.code == 1) {
        this.boxTypeList = res.data;
      }
    },
    clickSearch(){
      this.page_no = 1
      this.page_size = 10
      this.searchList()
    },
    async searchList(){
        this.loading = true
        let order_field = ''
        let order_type = ''
        if(this.order_field_type.length==1){
            order_field=this.order_field_type[0]
        }else if(this.order_field_type.length==2){
            order_field=this.order_field_type[0]
            order_type=this.order_field_type[1]
        }
        if(this.DateValue1 == '' || this.DateValue1 == null || this.DateValue1 == undefined){
          this.DateValue1 = []
          var date = new Date();
          var year = date.getFullYear().toString();
          var month = (date.getMonth() + 1).toString();
          var day = (date.getDate()+2).toString();
          var sanshiyi = ['1','3','5','7','8','10','12']
          var sanshi = ['4','6','9','11']
          var ershiba = '2'
          var currentYear = Number(year)

          if(sanshiyi.includes(month)){
            if(month==12){
              if(day>31){
                day = Number(day)-31
                month = Number(month)-11
                year = Number(year)+1
                currentYear = Number(currentYear)+1
              }

              if(currentDay>31){
                currentDay = Number(currentDay)-31
                currentMonth = Number(currentMonth)+1
                currentYear = Number(currentYear)+1
              }
            }
            if(day>31){
              day = Number(day)-31
              month = Number(month)+1
            }
          }else if(sanshi.includes(month)){
            if(day>30){
              day = Number(day)-30
              month = Number(month)+1
            }
          }else if(month==ershiba){
            let run = 28
            if(year %4 == 0 && year %100 != 0 && year % 400 == 0){
              run = 29
            }
            if(day>run){
              day = Number(day)-Number(run)
              month = Number(month)+1
            }
          }
          var currentMonth = String(month);
          var currentDay = String(Number(day)+30);
          
          if(sanshiyi.includes(currentMonth)){
            if(currentMonth==12){
              if(currentDay>31){
                currentDay = Number(currentDay)-31
                currentMonth = Number(currentMonth)-11
                currentYear = Number(currentYear)+1
              }
            }
            if(currentDay>31){
              currentDay = Number(currentDay)-31
              currentMonth = Number(currentMonth)+1
            }
          }else if(sanshi.includes(currentMonth)){
            if(currentDay>30){
              currentDay = Number(currentDay)-30
              currentMonth = Number(currentMonth)+1
            }
          }
          if(currentMonth==ershiba){
            let run = 28
            if(year %4 == 0 && year %100 != 0 && year % 400 == 0){
              run = 29
            }
            if(currentDay>run){
              currentDay = Number(currentDay)-run
              currentMonth = Number(currentMonth)+1
            }
          }

          // 对月份和日期进行补零
          month = month <10 ? '0' + month : month;
          currentMonth = currentMonth <10 ? '0' + currentMonth : currentMonth;
          day = day < 10 ? '0' + day : day;
          currentDay = currentDay < 10 ? '0' + currentDay : currentDay;
          
          var currentDate = year + '-' + month + '-' + day ;
          var currentDateER = currentYear + '-' + currentMonth + '-' + currentDay;
          this.DateValue1 = [currentDate,currentDateER]
        }
        let form = {
            page_no:this.page_no,
            page_size:this.page_size,
            state_port_id:this.searchQuery1JXYJ,
            end_port_id:this.searchQuery2JXYJ,
            cases_gauge_type:this.searchQuery3JXYJ,
            set_sail_start_time:this.DateValue1[0],
            set_sail_end_time:this.DateValue1[1],
            is_transit:this.is_transit,
            shipping_company_code:this.shipping_company_code,
            box_source:this.box_source,
            order_field:order_field,
            order_type:order_type,
        } 
        if(this.searchQuery3JXYJ !=undefined){
          if(this.searchQuery3JXYJ.length>0){
            this.searchQuery3JXYJ=this.searchQuery3JXYJ.sort()
          }
        }
        try {
            const res = await currentCabinSelect(form,this.headers)
            if(res.code == 1){
                // this.resultsList = [...res.data.lists]
                let data = [...res.data.lists]

                if(data.length==0){
                  this.kefuForm = res.data.kefu_info 
                  this.onlineForm.pol_id = this.searchQuery1JXYJ
                  this.onlineForm.pol_name = this.statePortForm 
                  this.onlineForm.pod_id = this.searchQuery2JXYJ
                  this.onlineForm.pod_name = this.endPortForm
                  this.onlineForm.kefu_id = res.data.kefu_info.id

                }

                this.total = res.data.count
                this.loading = false
                this.boxTitleList=[]
                this.options=[{
                  value: "etd",
                  label: "开航时间最近",
                },
                {
                  value: "tt",
                  label: "航程最短",
                }]
                this.timeA = res.data.time

                this.onlineForm.box_quantity = []
                for (let i = 0; i < this.searchQuery3JXYJ.length; i++) {
                  this.boxTitleList.push(this.searchQuery3JXYJ[i])

                  this.options.push({
                    value: this.searchQuery3JXYJ[i],
                    label: this.searchQuery3JXYJ[i],
                    children:[{
                      value: "asc",
                      label: "升序",
                    },
                    {
                      value: "desc",
                      label: "降序",
                    }]
                  })

                  this.onlineForm.box_quantity.push({
                      box:this.searchQuery3JXYJ[i],
                      quantity:0,
                  })
                }


                // 箱型匹配
                let boxTit = JSON.parse(JSON.stringify(this.searchQuery3JXYJ))
                this.resultsList=[]
                for (let i = 0; i < data.length; i++) {
                  this.resultsList.push(data[i])
                  for (let j = 0; j < data[i].basic_freight.length; j++) {
                    let cunzai = boxTit.includes(data[i].basic_freight[j].box_type)
                    if(!cunzai){
                      this.resultsList[i].basic_freight.splice(j,1)
                      j=j-1
                      // this.resultsList[i].basic_freight[j] = {
                      //   box_type:'',
                      //   dead_freight:'0',
                      //   dead_freight_name:'0',
                      //   number:'0',
                      //   overweight:'',
                      //   price:'--',
                      //   weight_limit:'',
                      // }
                    }
                  }
                }
            }else{
                this.resultsList = []
                this.total = 0
                this.loading = false
                this.boxTitleList=[]
                this.options=[{
                  value: "etd",
                  label: "开航时间最近",
                },
                {
                  value: "tt",
                  label: "航程最短",
                }]

                this.$message({
                  type:'error',
                  message:res.msg
                })
              }
        } catch (error) {
          this.loading = false
            console.log(error,'失败');
        }
    },
    // 复制舱位号
    getCopy(e){
      // navigator.clipboard.writeText(e).then(() => {
      //     this.$message({
      //         type:'success',
      //         message:'复制成功'
      //     })
      // }).catch(err => {
      //     console.error('复制失败: ', err);
      //     this.$message({
      //         type:'error',
      //         message:'复制失败'
      //     })
      // });

      if (navigator.clipboard && window.isSecureContext) {
        this.$message.success('复制成功')
        return navigator.clipboard.writeText(e)
      } else {
        const textarea = document.createElement('textarea');
        textarea.value = e
        document.body.appendChild(textarea);
        textarea.select();
        const successful = document.execCommand('copy');
        if(successful){
          this.$message.success('复制成功')
          textarea.remove()
        }else{
          this.$message.success('复制失败')
          textarea.remove()
        }
      }
    },
    // 价格复制
    getPriceCopy(e){
      let yunjia = ''
      for (let i = 0; i < e.basic_freight.length; i++) {
        if(e.basic_freight[i].box_type!='' && e.basic_freight[i].price!='--'){
          yunjia += e.basic_freight[i].price + '/' + e.basic_freight[i].box_type + ' '
        }
      }
      let tdlx = e.bill_of_lading_type_desc
      let zz = e.is_transit == 1 ? '中转' : '直达'
      let copy = '起运港：' + e.pol_name + '\n' + 
      '目的港：' + e.pod_name + '\n' + 
      '船公司：' + e.shipping_company.name_cn + '-' + e.shipping_company.name_en + '\n' + 
      '航线：' + e.routeCd + '\n' + 
      '船名/航次：' + e.vessel + '/' + e.voyage + '\n' +
      '运价：' + yunjia + '\n' +
      '运输条款：' + e.transportation_terms + '\n' +
      '箱源：' + e.box_source + '\n' +
      '提单类型：' + tdlx + '\n' +
      '中转/直达：' + zz + '\n' +
      'ETD：' + e.etd + '\n' +
      '目的港免堆/免用箱：' + e.freetime_desc + '\n' +
      '运价有效期：' + e.freight_rate_state_time + '至' + e.freight_rate_end_time 
      
      // navigator.clipboard.writeText(copy).then(() => {
      //     this.$message({
      //         type:'success',
      //         message:'复制成功'
      //     })
      // }).catch(err => {
      //     console.error('复制失败: ', err);
      //     this.$message({
      //         type:'error',
      //         message:'复制失败'
      //     })
      // });

      if (navigator.clipboard && window.isSecureContext) {
        this.$message.success('复制成功')
        return navigator.clipboard.writeText(copy)
      } else {
        const textarea = document.createElement('textarea');
        textarea.value = copy
        document.body.appendChild(textarea);
        textarea.select();
        const successful = document.execCommand('copy');
        if(successful){
          this.$message.success('复制成功')
          textarea.remove()
        }else{
          this.$message.success('复制失败')
          textarea.remove()
        }
      }
    },
    // 现舱倒计时
    daojishi(endTime){
      // const now = new Date().getTime()
      // const endTimetamp = new Date(endTime).getTime()
      const now = this.timeA
      const endTimetamp = endTime
      const remainingTime = endTimetamp - now

      if(remainingTime<=0){
        return '已下线'
      }


    //   var date = new Date(remainingTime * 1000); // 注意：乘以1000转换为毫秒级时间戳
    // // 获取时分秒并格式化
    //   var hours = String(date.getHours()).padStart(2, '0');
    //   var minutes = String(date.getMinutes()).padStart(2, '0');
    //   var seconds = String(date.getSeconds()).padStart(2, '0');
    //   return `${hours}小时 ${minutes}分钟 ${seconds}秒`

      // 总秒数
				var second = Math.floor(remainingTime);
				// 天数
				// var day = Math.floor(second / 3600 / 24);
				// 小时
				// var hr =  Math.floor(second / 3600 % 24);
				var hr =  Math.floor(second / 60 / 60);
				// 分钟
				var min = Math.floor(second / 60 % 60);
				// 秒
				var sec = Math.floor(second % 60);

        return `${hr}小时 ${min}分钟 ${sec}秒`
    },
    // 获取箱源
    async getXiangYuan(){
      let params = {
        type: 'box_source'
      };
      const res = await dict(params);
      if (res.code==1) {
        this.boxsourceList=res.data.box_source
      }
    },
    // 获取船公司
    async getShip(){
      this.loadingShip = true;
      const res = await baseShippingCompanyValidList();
      if (res.code == 1) {
        this.shippingList = res.data;
      }
      this.loadingShip = false
    },
    // 在线留言
    onlineMessage(e){
      console.log('fa',e)

      this.onlineForm.pol_id = e.pol_id
      this.onlineForm.pol_name = e.pol_name
      this.onlineForm.pod_id = e.pod_id
      this.onlineForm.pod_name = e.pod_name
      this.onlineForm.kefu_id = e.kefu_info.id
      
      let tdlx = e.bill_of_lading_type_desc
      let zz = e.is_transit == 1 ? '中转' : '直达'
      let ggsSn =  e.supplier_info.sn

      if(e.type==3){
        ggsSn = '上海泛远国际货运代理有限公司'
      }

      let yunjia = ''
      for (let i = 0; i < e.basic_freight.length; i++) {
        if(e.basic_freight[i].box_type!='' && e.basic_freight[i].price!='--'){
          yunjia += e.basic_freight[i].price + '/' + e.basic_freight[i].box_type + ' '
        }
      }

      this.onlineForm.shipping_space_info = {
        type:e.type,
        shipping_company:e.shipping_company,
        routeCd:e.routeCd,
        vessel:e.vessel,
        voyage:e.voyage,
        transportation_terms:e.transportation_terms,
        box_source:e.box_source,
        bill_of_lading_type_desc:tdlx,
        is_transit:zz,
        etd:e.etd,
        freetime:e.freetime_desc,
        freight_rate_state_time:e.freight_rate_state_time,
        freight_rate_end_time:e.freight_rate_end_time,
        supplier_info:ggsSn,
        order_sn:e.order_sn,
        basic_freight:yunjia,
      }
      
      this.dialogLiuyan = true
    },
    validFn(email) {
        if(email==''){
            this.$message({
                message: "请输入邮箱地址",
                type: "error",
            });
            return false;
        }
        
        if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) {
            this.$message({
                message: "请输入正确的邮箱地址",
                type: "error",
            });
            return false;
        }
        return true;
    },
    async submitMessage(){
        try {
            // 判断验证是否通过
            if (!this.validFn(this.onlineForm.email)) {
                return;
            }

            if (this.isSubmitting) return;  // 防止连点操作  

            this.isSubmitting = true;

            const res = await shipReplyAdd(this.onlineForm,this.headers)
            if(res.code==1){
                this.isSubmitting = false;

                this.$message({
                    type:"success",
                    message:'成功'
                })
                this.dialogLiuyan = false
                this.jiehe = 1

                this.onlineForm.content = ''
                this.onlineForm.shipment_date = ''
                
            }else{
                this.isSubmitting = false;

                this.$message({
                    type:"error",
                    message:res.msg
                })
            }
        } catch (error) {
            console.log(error,'error');
        }
    },
    showKefu(e){
      this.kefuForm = e.kefu_info
      this.cunForm = e
      this.dialogVisible = true
    },
    onlineMessageNAN(){
      this.dialogLiuyan = true
    },
    showKefunNAN(){
      this.dialogVisible = true
    }
  },
  mounted() {
    this.canshu = this.$route.params;

    if(this.canshu.qi!='' && this.canshu.qi!=undefined && this.canshu.qi!=null){
      this.searchQuery1JXYJ=this.canshu.qi
      this.searchQuery2JXYJ=this.canshu.mu
      this.searchQuery3JXYJ=this.canshu.boxtype
      this.statePortForm=this.canshu.statePortForm
      this.endPortForm=this.canshu.endPortForm
      if(this.canshu.createTime !=undefined){
        this.DateValue1 = [this.canshu.createTime,this.canshu.endTime]
      }
      this.searchList()
    }
    if(localStorage.getItem("userInfo")){
          let user = JSON.parse(localStorage.getItem("userInfo"))
          this.onlineForm.email = user.email
          this.onlineForm.nickname = user.nickname
    }
    this.getQygList();
    this.getMdgList();
    this.getBoxTypeList();
    this.getXiangYuan()
    this.getShip()

    this.intervalId = setInterval(() =>{
      this.timeA += 1
      this.resultsList = [...this.resultsList]
    },1000)
  },
  onBeforeUnmount(){
    clearInterval(this.intervalId)
  }
};
</script>

<style lang="scss" scoped>
.topNavigation {
  height: 100PX;
  display: flex;
  justify-content: space-between;
  padding: 0 80px;
  background: #fff;
}

.searchResult {
  background: #f9f9f9;
}

.typeArea {
  width: 1200px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  margin-bottom: 32px;
}

.el-breadcrumb {
  margin: 20px 0;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #999999;
  line-height: 16px;
  text-align: left;
  font-style: normal;
  text-transform: none;
  .el-breadcrumb__inner is-link {
    color: pink;
  }
}

:deep(.el-breadcrumb) {
  .el-breadcrumb__inner {
    color: #999999 !important;
  }
  .bread {
    span {
      color: #0073f5 !important;
    }
  }
}

.conditiobn {
  // width: 1200px;
  box-sizing: border-box;
  height: 269px;
  background: #ffffff;
  border-radius: 12px 12px 12px 12px;
  padding: 24px;

  :deep(.el-select) {
    input {
      background: #f9f9f9;
      border: 0;
      padding: 0;
    }
  }

  .title {
    display: flex;
    align-items: center;
    span {
      height: 28px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 20px;
      color: #333333;
      line-height: 28px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }

    img {
      width: 42px;
      margin: 0 12px;
    }
  }
}

.line {
  width: 100%;
  height: 1px;
  background: #eee;
  margin: 24px 0;
}

.condition {
  display: flex;
  align-items: center;

  :deep(.el-select) {
    input {
      background: #f9f9f9;
      border: 0;
      padding: 15px;
    }
  }
  .img {
    width: 24px;
    height: 24px;
  }
  .span {
    // width: 32px;
    // height: 22px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    line-height: 19px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    margin-left: 8px;
    margin-right: 20px;
  }
  .el-select,
  .el-cascader {
    margin-right: 12px;
  }

  :deep(.el-input__inner) {
    width: 240px;
    height: 48px;
    background: #f9f9f9;
    border: 0;
  }
}

.result {
  // width: 1200px;
  // height: 1662px;
  background: #fff;
  border-radius: 12px 12px 12px 12px;
  margin-top: 20px;
  margin-bottom: 24px;
  // padding: 24px;

  .table-header {
    display: flex;

    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #333333;
    line-height: 16px;
    text-align: left;
    font-style: normal;
    text-transform: none;
    padding: 24px;

    border-bottom: #eee 1px solid;
    .qi {
      margin-left: 48px;
      margin-right: 218px;
    }

    .mu{
      margin-right: 216px;
    }
    .gp {
      margin-right: 64px;
    }
    .hq {
      margin-left: 0px;
    }
  }

  .table-tbody {
    .neirongzhezhao{
      position: relative;
      filter: blur(4px);
      user-select: none;
    }

    .neirong {
      padding: 24px 0;
      margin: 0 24px;
      border-bottom: #eee 1px solid;
    }

    .neirong:last-child {
      border: 0;
    }
    .shang {
      display: flex;
      align-items: center;
      justify-content: space-between;
      .shang-le{
        display: flex;
        align-items: center;
        width: 100%;
      }
      .logo {
        width: 40px;
        height: 40px;
        margin-right: 50px;

        img{
          width: 65px;
        }
      }
      .qiyun {
        width: 130px;
        .date {
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 16px;
          color: #333333;
          line-height: 19px;
          text-align: left;
          font-style: normal;
          text-transform: none;

          margin-bottom: 4px;

          .jiacu{
            font-weight: bold;
          }
        }
        .address {
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #606266;
          line-height: 16px;
          text-align: left;
          font-style: normal;
          text-transform: none;

          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .dao {
        width: 100px;
        text-align: center;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 12px;
        color: #606266;
        font-style: normal;
        text-transform: none;

        margin: 0 20px;
        img {
          width: 100px;
          height: 7px;
        }
        div {
          height: 12px;
        }
      }

      .qian {
        margin-left: 38px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        text-align: left;
        font-style: normal;
        text-transform: none;
        span:first-child {
          color: #606266;
          margin-right: 20px;
        }
        span:nth-child(3) {
          margin: 0 35px;
        }
        span {
          color: #fe3300;
        }
      }

      .qian-tit {
          width: 70px;
          display: inline-block;
          text-align: right;
        }
        .qian-tite {
          margin-top: 6px;
          color: #606266;
        }
    }

    .btn {
      margin-top: 24px;
      display: flex;
      justify-content: flex-end;
      .fymx {
        width: 88px;
        height: 40px;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #D9276D;
        text-align: center;
        color: #D9276D;
        background: #fff;
        display: flex;
        justify-content: center;
        margin-left: 12px;
      }
      .dc{
        width: 88px;
        height: 40px;
        background: #D9276D;
        border-radius: 8px 8px 8px 8px;
        color: #fff;
        border: 0;
        padding: 0;
        margin-left: 12px;
      }
    }

    .zhong {
      display: flex;

      margin-top: 16px;
      margin-bottom: 12px;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #606266;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      div {
        margin-right: 48px;
      }
      .kuan {
        width: 130px;
      }
    }

    .xia {
      display: flex;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #606266;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;

      .kuan {
        width: 130px;
        margin-right: 48px;

        display: flex;
      }

      .kuan:nth-child(2) {
        width: 132px;
        margin-right: 42px;
      }
      .cilick {
        cursor: pointer;
        color: #D9276D;
      }
    }

    .xiaxia{
      margin-top: 12px;
      .youbian{
        margin-right: 48px;
      }

      .copy{
        color: #D9276D;
        cursor: pointer;
      }
    }
  }
}

.el-popover {
  p {
    color: #606260;
  }
  span {
    color: #fe3300;
  }
}

:deep(.el-pagination) {
  margin-bottom: 32px;
  display: flex;
  justify-content: flex-end;
  button,
  li {
    background: #fff !important;
  }
  li.active {
    background-color: #409eff !important;
    color: #fff;
  }
}
.delivery-main {
  // width: 1152px;
  // height: 72px;
  background: #f9f9f9;
  border-radius: 8px 8px 8px 8px;
  margin-top: 20px;
  box-sizing: border-box;
  padding: 14px 8px 14px 16px;
  display: flex;
  justify-content: space-between;
  .delivery-main-box {
    border-right: 1px solid #ddd;
    padding-right: 8px;
    height: 48px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &:nth-child(-n + 2) {
      width: 300px;
    }
    &:nth-child(n + 2) {
      margin-left: 8px;
    }
    &:nth-child(3) {
      width: 200px;
      input {
        width: 130px;
      }
    }
    &:nth-child(4) {
      border: 0;
      width: 220px;
    }
    .dateSpan {
      margin-right: 12px;
    }
    img {
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }
    .address {
      width: 304px;
      // div:first-child{
      //   color: #666;
      // }
      div {
        display: block;
        height: 20px;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #999999;
        line-height: 16px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
      input {
        width: 100%;
        border: none;
        outline: none;
        background: #f9f9f9;
        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #999999;
        line-height: 16px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
      input {
        color: #333;
        margin-top: 4px;
      }
      input::placeholder {
        color: #ccc;
      }
      .el-icon-date:before {
        content: "";
      }
      .el-input {
        display: inline-block;
        width: 80px;
      }
      .el-input--prefix .el-input__inner {
        padding-left: 0;
        padding-right: 0;
        width: 80px;
        height: 20px;
        font-size: 14px;
        display: inline-block;
      }
    }

    // 选择开关
    .switch {
      width: 100px;
      height: 34px;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;
      box-sizing: border-box;
      padding: 4px;
      display: flex;
      div {
        // width: 43px;
        height: 100%;
        border-radius: 8px 8px 8px 8px;
        color: #999999;
        padding: 3px 7px;
        font-size: 14px;
        box-sizing: border-box;
        &:nth-child(1) {
          margin-right: 4px;
        }
      }
    }
  }
  .search {
    width: 52px;
    height: 52px;
    background: #0073f5;
    border-radius: 8px 8px 8px 8px;
    display: flex;
    justify-content: center;
    align-items: center;
    i {
      color: #fff;
      font-size: 20px;
    }
  }

  // 日期选择器
  :deep(.el-date-editor) {
    width: 200px !important;
    border: 0px;
    background: #f9f9f9;
    padding: 0;
    display: flex !important;
    align-items: baseline;
    height: 20px;
    input {
      background: #f9f9f9;
    }
    i.el-input__icon.el-range__icon.null {
      width: 0px;
    }
    .el-date-editor .el-range-separator {
      height: 20px;
    }
  }
}
.delivery-main-1 {
  flex-wrap: wrap;
  padding-bottom: 0;
  .delivery-main-box {
    margin-bottom: 16px;
    &:nth-child(n + 1) {
      width: 360px;
    }
    // &:nth-child(n + 2) {
    //   margin-left: 8px;
    // }
    &:nth-child(3n) {
      border: 0;
    }
    &:nth-child(4) {
      border-right: 1px solid #ddd;
      margin-left: 0px;
    }
  }
}

.youjiantou {
  position: relative;
  .youbian {
    position: absolute;
    // left: 316px;
    top: 18px;
    right: -18px;
  }
  .youbianvv {
    top: 13px;
  }
}

.jiantou {
  margin-right: 10px;
}

.el-dropdown {
  position: relative;
  span {
    position: absolute;
    top: -5px;
    right: 20px;
  }
}
// 下拉港口
.noDate {
  padding: 20px;
  color: #666;
}

.mudig {
  padding: 10px 20px 20px 20px;
  box-sizing: border-box;
  width: 500px;
  .mdglist {
    :deep(.el-select-group) {
      display: flex;
      flex-wrap: wrap;
    }
  }
  :deep(.el-select) {
    ul.el-select-group {
      display: flex;
    }
  }
}

.xiangxing {
  :deep(.el-select__tags) {
    margin-top: 10px;
    span.el-tag.el-tag--info.el-tag--small.el-tag--light {
      margin: 2px 6px 2px 0;
    }
  }
}

.sumPrice{
    display: inline-block;
    width: 50px;
}

.el-drawer{
  .drawer-title{
    height: 92px;
    padding: 32px;

    display: flex;
    justify-content: space-between;
    border-bottom: #eee 1px solid;
    .word{
      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 20px;
      color: #333333;
      font-style: normal;
      text-transform: none;
      span{
        color: #999999;
        font-size: 14px;
        margin-left: 8px;
      }
    }

    i{
      font-size: 28px;
      color: #999;
      cursor: pointer;
    }
  }
  .tab-det{
    padding: 32px 32px 0 32px;
  }

  .tab-tit{
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 16px;
    color: #333333;
    font-style: normal;
    text-transform: none;

    margin-bottom: 20px;
  }
 

  .drawer__footer{
    width: 100%;
    height: 80px;
    border-radius: 0px 0px 0px 0px;

    margin-top: 236px;

    display: flex;
    align-items: center;
    justify-content: flex-end;

    border-top: 1px #eee solid;

    .quxiao{
      width: 100px;
      height: 40px;
      background: #F9F9F9;
      border-radius: 8px 8px 8px 8px;
      border: 0;
      color: #999999;
      font-size: 14px;
      margin-right: 16px;
    }

    .dingcanggg{
      width: 100px;
      height: 40px;
      background: #0073F5;
      border-radius: 8px 8px 8px 8px;
      color: #fff;
      border: 0;
      font-size: 14px;
      margin-right: 32px;
    }
  }
}
.table{
    width: 100%;
    border-spacing: 0;
    border-collapse: collapse;

    td{
      padding-left: 12px;
    }
    .theader{
        height: 48px;
        background: #F9F9F9;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #999999;
        font-style: normal;
        text-transform: none;
        
    }
    .tbody{
        height: 68px;
        background: #fff;

        font-family: PingFang SC, PingFang SC;
        font-weight: 500;
        font-size: 14px;
        color: #333333;
        font-style: normal;
        text-transform: none;

    }

    .zanweu{
      text-align: center;
    }
}

.renminbi{
  margin-top: 24px;
}

.datab{
  margin-top: 20px;
  border: solid 1px #eee;

  .xiaotab{
    padding: 0;
  }
}

  // 不是vip的弹窗 
  .noVip{
    position: relative;
  }
  .noVip-dialog{
    position: absolute;
    top: 438px;
    left: 50%;
    transform: translate(-50%, 0);
    
    width: 448px;
    height: 306px;
    background: #FFFFFF;
    box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.08);
    border-radius: 16px 16px 16px 16px;
    text-align: center;

    .novip-tit{
      font-weight: bold;
      font-size: 20px;
      color: #333333;
      margin-bottom: 24px;
      margin-top: 32px;
    }

    .noVip-line{
      display: flex;
      justify-content: center;
      align-items: center;
      .left-line{
        width: 128px;
        height: 1px;
        background: #D9276D;
      }

      .word{
        font-weight: 500;
        font-size: 16px;
        color: #D9276D;
        margin: 0 8px;
      }
    }

    .noVip-gongneng{
      display: flex;
      align-items: center;
      justify-content: space-around;
      margin-top: 20px;
      margin-bottom: 32px;
      .gongnengYi{
        font-weight: 500;
        font-size: 14px;
        color: #999999;
        img{
          width: 40px;
          height: 40px;
        }
      }
    }

    .noVip-btn{
      .noVip-qy{
        width: 200px;
        height: 48px;
        background: #EEEEEE;
        border-radius: 24px 24px 24px 24px;
        font-weight: 500;
        font-size: 16px;
        color: #666666;
        border: 0;
      }
      .noVip-hy{
        width: 200px;
        height: 48px;
        background: #0073F5;
        border-radius: 24px 24px 24px 24px;
        font-weight: 500;
        font-size: 16px;
        color: #FFFFFF;
      }
    }
  }

.dialogBox{
  display: flex;
  justify-content: space-around;
}

.kuanA{
    margin-right: 24px;
  }


.ddDialog{
    :deep(.el-dialog){
        width: 1200px;
        // height: 800px;

        .el-dialog__close{
            font-size: 24px;
            color: #455B73;
        }
    }

    .dd-con{
        margin: 0 34px;
    }

    .dd-con-yi{
        justify-content: space-between;
        margin-bottom: 28px;
        .dd-con-yi-width{
            width: 534px;

            :deep(.el-select){
                input{
                    width: 534px;
                    height: 48px;
                    background: #FFFFFF;
                    border-radius: 2px 2px 2px 2px;
                    border: 1px solid #DADFE9;
                    font-size: 20px;
                    color: #171B47;
                }
            }

            :deep(.el-input){
                input{
                    width: 534px;
                    height: 48px;
                    background: #FFFFFF;
                    border-radius: 2px 2px 2px 2px;
                    border: 1px solid #DADFE9;
                    font-size: 20px;
                    color: #171B47;
                }
            }

            :deep(.el-date-editor){
                width: 534px;
                height: 48px;
                .el-input__icon{
                    font-size: 20px;
                    color: #D9276D;
                }
            }

            .dd-con-yi-box{
                width: 534px;
                height: 48px;
                background: #FFFFFF;
                border-radius: 2px 2px 2px 2px;
                border: 1px solid #DADFE9;
                font-size: 20px;
                color: #171B47;

                justify-content: space-between;

                .boxSty{
                    height: 35px;
                    background: #F6F7FA;
                    border-radius: 4px 4px 4px 4px;
                    margin-left: 20px;
                    font-weight: 400;
                    font-size: 18px;
                    padding: 0 12px;

                    .el-error{
                        margin-left: 12px;
                        width: 20px;
                        height: 20px;
                        background: #DCE0EB;
                        border-radius: 31px 31px 31px 31px;
                        cursor: pointer;
                    }
                    .el-icon-close{
                        font-size: 20px;
                        color: #787F99;
                        line-height: 20px;
                    }
                }

                .icondown{
                    font-size: 20px;
                    margin-right: 20px;
                }
            }
        }
    }

    .dd-con-er{
        :deep(.el-textarea) {
            .el-textarea__inner {
                height: 245px;
                background: #FFFFFF;
                border-radius: 2px 2px 2px 2px;
                border: 1px solid #DADFE9;
                font-size: 20px;
                color: #171B47;
            }
        }
    }

    .dd-con-tit{
        font-weight: 400;
        font-size: 18px;
        color: #171B47;
        margin-bottom: 11px;
        span{
            color: #D9276D;
        }
    }

    .dialog-footer{
        text-align: center;

        .quxiao{
            width: 128px;
            height: 52px;
            border-radius: 2px 2px 2px 2px;
            border: 1px solid #A2AFC9;

            font-size: 24px;
            color: #171B47;
        }
        .queding{
            margin-left: 32px;
            width: 128px;
            height: 52px;
            background: #D9276D;
            border-radius: 2px 2px 2px 2px;
            font-size: 24px;
            color: #FFFFFF;
            border: none;
        }
    }
}


.emailDialog{
    :deep(.el-dialog){
        width: 1200px;
        // height: 790px;

        .el-dialog__close{
            font-size: 24px;
            color: #455B73;
        }
    }

    .dd-con{
        margin: 0 34px;
    }

    .dd-con-yi{
        margin-bottom: 28px;

        :deep(.el-input){
            input{
                height: 48px;
                background: #FFFFFF;
                border-radius: 2px 2px 2px 2px;
                border: 1px solid #DADFE9;
                font-size: 20px;
                color: #171B47;
            }
        }
    }

    .dd-con-er{
        :deep(.el-textarea) {
            .el-textarea__inner {
                height: 245px;
                background: #FFFFFF;
                border-radius: 2px 2px 2px 2px;
                border: 1px solid #DADFE9;
                font-size: 20px;
                color: #171B47;
            }
        }
    }

    .dd-con-tit{
        font-weight: 400;
        font-size: 18px;
        color: #171B47;
        margin-bottom: 11px;
        span{
            color: #D9276D;
        }
    }

    .dialog-footer{
        text-align: center;
        margin-top: 24px;
        .quxiao{
            width: 128px;
            height: 52px;
            border-radius: 2px 2px 2px 2px;
            border: 1px solid #A2AFC9;

            font-size: 24px;
            color: #171B47;
        }
        .queding{
            margin-left: 32px;
            height: 52px;
            width: 128px;
            background: #D9276D;
            border-radius: 2px 2px 2px 2px;
            font-size: 24px;
            color: #FFFFFF;
            border: none;
        }
    }
}

.el-tag{
    margin-right: 12px;
    margin-bottom: 12px;
    font-size: 16px;
    height: 100%;
    padding: 4px 12px;
}

.button-new-tag{
    font-size: 16px;
}


.txhz{
  display: flex;
  align-items: center;
}

.appdialog{
    :deep(.el-dialog){
        width: 1100px;
        height: 329px;
        background: #FFFFFF;
        .el-dialog__header,.el-dialog__body{
            padding: 0;
        }

        .applan{
            height: 10px;
            background: #2A1D62;

            .appfen{
                width: 138px;
                height: 10px;
                background: #0073f5;
            }
        }

        .dingwei{
            position: relative;
        }

        .dhk-xia{
            display: flex;
            align-items: center;
            height: 217px;
            padding: 0 42px;
            box-sizing: border-box;
        }

        .dizhi{
            height: 102px;
            background: #F8F8F8;

            display: flex;
            align-items: center;
            padding-left: 45px;
            .kflogoIng{
                // width: 58px;
                height: 58px;
                margin-right: 15px;
            }

            .dx-tit{
                font-family: DSemiBold;
                font-weight: 600;
                font-size: 22px;
                color: #2A1D62;
                margin-bottom: 10px;
            }

            .dz-wprd{
                font-family: DMedium;
                font-weight: 500;
                font-size: 16px;
                color: #3B3169;

                span{
                    color: #E15B90;
                }
            }
        }
       
        .el-icon-close{
            font-size: 24px;
            color: #2A1D62;
            cursor: pointer;

            position: absolute;
            top: 20px;
            right: 24px;
        }

        .txDingwei{
            position: relative;
            width: 120px;
            height: 100%;
            margin-right: 36px;
            .zanwu{
              text-align: center;
              width: 100%;
              height: 140px;
              border: 1px solid #ccc;
              line-height: 140px;
              color: #666;
            }
            .delImg{
                position: absolute;
                right: 6px;
                bottom: 10px;
                width: 24px;
                height: 24px;
                cursor: pointer;
            }
        }
            
        .touxImg{
            width: 120px;
            object-fit: cover;
            max-height: 200px;
            // height: 146px;
            // height: 100%;
        }

        .xia-left{
            display: flex;
            color: #16103D;
            .kfdzimg{
                width: 38px;
                height: 38px;
            }

            .txname{
                font-family: PMedium;
                color: #16103D;
                font-size: 28px;
            }

            .neior{
                margin-top: 12px;
                margin-bottom: 15px;
                width: 262px;
                height: 46px;

                background-image:url('@/assets/home/dingweiBj.png');	
                background-repeat: no-repeat;
                background-size:100% 100%;

                font-weight: 500;
                font-size: 13px;
                color: #2A1D62;
                font-family: PMedium;
                padding-left: 10px;
                padding-right: 40px;
                padding-top: 8px;
                box-sizing: border-box;
            }

            .wangzhi{
                font-weight: 400;
                font-size: 18px;
                color: #D9276D;
                display: flex;
                align-items: center;
                .img{
                    width: 28px;
                    height: 28px;
                    margin-right: 4px;
                }
                a{
                    color: #D9276D;
                }
            }
        }

        .xia-line{
            margin-left: 22px;
            margin-right: 22px;
            height: 138px;
            border: 1px solid #DCDDEA;
        }

        .xia-right{
            .tx-xx{
                margin-bottom: 17px;
                font-weight: 400;
                font-size: 18px;
                color: #171B47;
                display: flex;
                align-items: center;
                .tx-img{
                    width: 24px;
                    height: 24px;
                    margin-right: 16px;
                }

                .span{
                    font-size: 16px;
                    color: #787DAA;
                }

                .copyimg{
                    cursor: pointer;
                    width: 20px;
                    height: 20px;
                    margin-left: 4px;
                }

                .el-button{
                  color: #D9276D;
                  margin-left: 4px;
                }
            }
            .clickImg{
              width: 24px;
              height: 24px;
              margin-left: 4px;
            }

            .youxiang{
              cursor: pointer;
            }
        }
    }
}

.dd-con-yi-boxtype{
    padding: 16px 16px 4px;
    box-sizing: border-box;
    .boxtype{
        padding: 12px;
        
        .boxtype-left{
            margin-right: 24px;
        }
    }

    .boxtypeLine{
        border-bottom: 1px solid #F5F6F9;
    }
}

.empty-btn{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  .fymx {
    width: 88px;
    height: 40px;
    border-radius: 8px 8px 8px 8px;
    border: 1px solid #D9276D;
    text-align: center;
    color: #D9276D;
    background: #fff;
    display: flex;
    justify-content: center;
    margin-left: 12px;
  }

  .fr{
    margin-right: 60px;
  }
}
</style>